import { render, staticRenderFns } from "./AllConfigurationsCompany.vue?vue&type=template&id=4aeff10f&scoped=true&"
import script from "./AllConfigurationsCompany.vue?vue&type=script&lang=js&"
export * from "./AllConfigurationsCompany.vue?vue&type=script&lang=js&"
import style0 from "./AllConfigurationsCompany.vue?vue&type=style&index=0&id=4aeff10f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeff10f",
  null
  
)

export default component.exports